"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethods = void 0;
var PaymentMethods;
(function (PaymentMethods) {
    PaymentMethods["TINKOFF"] = "TINKOFF";
    PaymentMethods["PRODAMUS"] = "PRODAMUS";
    PaymentMethods["STRIPE"] = "STRIPE";
    PaymentMethods["TINKOFF_INVOICE"] = "TINKOFF_INVOICE";
})(PaymentMethods || (exports.PaymentMethods = PaymentMethods = {}));
//# sourceMappingURL=payment-methods.enum.js.map